import { DealerGeoInput } from '@app-domains/meilisearch/types/dealer-search.types'
import { ProductFilterInput } from '@app-domains/meilisearch/types/product-search.types'

export type MeilisearchRequestContext = {
    baseFilters: ProductFilterInput[]
}

export type DealerRequestContext = {
    geo?: DealerGeoInput
}

export const MEILISEARCH_CONTEXT_PARAM = '__meilisearchContext'
export const DEALER_CONTEXT_PARAM = '__dealerContext'

export function withMeilisearchContext(context: MeilisearchRequestContext): Record<string, string> {
    return { [MEILISEARCH_CONTEXT_PARAM]: JSON.stringify(context) }
}

export function withDealerContext(context: DealerRequestContext): Record<string, string> {
    return { [DEALER_CONTEXT_PARAM]: JSON.stringify(context) }
}

export function decodeMeilisearchContext(params: Record<string, unknown>): MeilisearchRequestContext {
    const raw = params[MEILISEARCH_CONTEXT_PARAM]
    if (typeof raw !== 'string') return { baseFilters: [] }
    try {
        const parsed = JSON.parse(raw) as MeilisearchRequestContext
        return { baseFilters: parsed.baseFilters ?? [] }
    } catch { return { baseFilters: [] } }
}

export function decodeDealerContext(params: Record<string, unknown>): DealerRequestContext {
    const raw = params[DEALER_CONTEXT_PARAM]
    if (typeof raw !== 'string') return {}
    try { return JSON.parse(raw) as DealerRequestContext } catch { return {} }
}
